import { appendRow, deleteRow, ensureTab, findRowIndexById, getRows, updateRow } from '../lib/googleSheets';

export function createSheetService(title, headers) {
  const toObject = (row) => Object.fromEntries(
    headers.map((header, index) => [header, row?.[index] ?? ''])
  );

  const toValues = (record) => headers.map((header) => record[header] ?? '');

  async function list() {
    await ensureTab(title, headers);
    const rows = await getRows(`${title}!A2:Z`);
    return rows.filter((row) => row?.[0]).map(toObject);
  }

  async function getById(id) {
    await ensureTab(title, headers);
    const rows = await getRows(`${title}!A:A`);
    const index = rows.findIndex((row, rowIndex) => rowIndex > 0 && row?.[0] === id);
    if (index < 0) return null;

    const rowNumber = index + 1;
    const row = await getRows(`${title}!A${rowNumber}:Z${rowNumber}`);
    return row[0] ? toObject(row[0]) : null;
  }

  async function create(record) {
    await ensureTab(title, headers);
    const now = new Date().toISOString();
    const completeRecord = {
      ...record,
      id: record.id || crypto.randomUUID(),
      created_at: record.created_at || now,
      updated_at: now
    };
    await appendRow(`${title}!A:Z`, toValues(completeRecord));
    return completeRecord;
  }

  async function update(record) {
    await ensureTab(title, headers);
    const rowNumber = await findRowIndexById(title, record.id);
    if (rowNumber < 0) throw new Error(`Record not found in ${title}.`);

    const current = await getRows(`${title}!A${rowNumber}:Z${rowNumber}`);
    const completeRecord = {
      ...toObject(current[0]),
      ...record,
      updated_at: new Date().toISOString()
    };
    await updateRow(`${title}!A${rowNumber}:Z${rowNumber}`, toValues(completeRecord));
    return completeRecord;
  }

  async function remove(id) {
    await ensureTab(title, headers);
    return deleteRow(title, id);
  }

  return { list, getById, create, update, remove };
}